import React from "react";
import ReactDOM from "react-dom";
import "@Styles/global.less";
import "@Styles/base.css";
import WebsiteNav from "@Components/websiteNav";

const $tcNav = document.getElementById("tcNav");

$tcNav &&
  ReactDOM.render(
    <>
      {/* <DefaultNav /> */}
      <WebsiteNav />
    </>,
    $tcNav,
  );
